module.exports = __webpack_public_path__ + "static/media/CTLA_8-356w.dad05b42.jpg";